import $ from 'jquery'
import router from '@/router';
import Swal from "sweetalert2";
import {notifyError} from "@/components/composables/messages";


export function maskMoneyTable(value) {
    var money = parseFloat(value);
    money = money.toLocaleString('pt-br', {style: 'currency', currency: 'BRL'});
    return money;
}

export function formatMoney(value) {
    if (value === '') return;

    // Remove todos os caracteres que não sejam dígitos
    var cleanValue = value.replace(/\D/g, '');

    // Divide o valor em parte inteira e decimal
    var integerPart = cleanValue.substring(0, cleanValue.length - 2);
    const verify = integerPart.charAt(0);
    if (parseInt(integerPart) > 1 && verify[0] === '0') integerPart = integerPart.slice(1);
    if (integerPart === '' || integerPart == 0) integerPart = '0';
    var decimalPart = cleanValue.substring(cleanValue.length - 2);
    if (decimalPart.length < 2) decimalPart = '0' + decimalPart;

    // Adiciona separador de milhar
    integerPart = integerPart.replace(/(\d)(?=(\d{3})+$)/g, '$1.');

    // Formata o valor como moeda (adiciona símbolo de moeda e sinal de negativo)
    return 'R$ ' + integerPart + ',' + decimalPart;
}

export function toDecimal(value) {
    var cleanValue = value.replace(/\D/g, '');

    // Divide o valor em parte inteira e decimal
    var integerPart = cleanValue.substring(0, cleanValue.length - 2);
    const verify = integerPart.charAt(0);
    if (parseInt(integerPart) > 1 && verify[0] === '0') integerPart = integerPart.slice(1);
    if (integerPart === '' || integerPart == 0) integerPart = '0';
    var decimalPart = cleanValue.substring(cleanValue.length - 2);
    if (decimalPart.length < 2) decimalPart = '0' + decimalPart;

    // Adiciona separador de milhar
    integerPart = integerPart.replace(/(\d)(?=(\d{3})+$)/g, '$1.');

    return integerPart + ',' + decimalPart;
}

export function getUrl(session) {
    const values = JSON.parse(localStorage.getItem(session));
    let url = values.url + '?';
    const params = values.params;
    const keys = Object.keys(values.params);

    for (let i = 0; i < keys.length; i++) {
        let result = params[keys[i]];
        url += `&${keys[i]}=${result}`;
    }

    return url;
}

export function formDataToJson(id) {
    // Acessar o formulário pelo seu ID
    const form = document.getElementById(id);
    if (!form) {
        console.error('Formulário não encontrado!');
        return null;
    }

    // Criar uma instância de FormData
    const formData = new FormData();

    formData.append('id', document.getElementById('id').value);

    const inputs = form.getElementsByClassName('form-control');
    Array.from(inputs).forEach(input => {
        // Verificar se é um campo de entrada de arquivo
        if (input.type === 'file') {
            // Adicionar cada arquivo selecionado ao objeto FormData
            for (let i = 0; i < input.files.length; i++) {
                formData.append(input.name, input.files[i]);
            }
        } else if (input.type !== 'submit' && input.type !== 'button' && input.name) {
            // Para outros tipos de campos, apenas adicionar ao FormData
            // Ignorando botões de envio e outros elementos interativos que não contêm dados "submetíveis"
            formData.append(input.name, input.value);
        }
    })


    return formData;
}

export function Forbidden(response) {

    if (response.response.status === 401 || response.response.status === 403) {
        localStorage.removeItem('token');
        router.push({
            name: 'login'
        });

        notifyError('Não autorizado');
        return;
    }

    notifyError(response.response);
}

export function maskCpfCnpj(value) {

    if (value.length <= 11) {
        return value.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
    } else {
        return value.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5");
    }
}

export async function deleteElement(message) {
    const text = message || "Seus dados serão removidos e não poderão mais ser recuperados.";
    return Swal.fire({
        title: "Você tem certeza?",
        text: text,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        cancelButtonText: "Cancelar",
        confirmButtonText: "Confirmar",
    }).then((result) => {
        return result.isConfirmed;
    });
}

export function loadTable() {
    const tbody = document.querySelector('#table tbody');
    if (tbody) tbody.style.opacity = '.2'
    loadCard();
}

export function loadCard(id) {
    if (id) {
        const element = document.getElementById(id);
        element.style.opacity = '.2'
    }
    const placeholderElement = document.querySelector('.simplebar-placeholder');
    const width = parseInt(placeholderElement.offsetWidth) / 2 + 30;

    if (document.getElementById('spinner')) {
        document.getElementById('spinner').style.display = 'block'
        document.getElementById('spinner').style.right = `calc(50% - ${width}px)`
    }
}

export function endLoadTable() {
    const tbody = document.querySelector('#table tbody');
    if (tbody) tbody.style.opacity = '1'

    endLoadCard();
}

export function endLoadCard(id) {
    if (id) {
        const element = document.getElementById(id);
        element.style.opacity = '1'
    }
    document.getElementById('spinner').style.display = 'none'
    document.getElementById('spinner').style.right = `calc(50% - 2.5rem)`
}

export function convertDateText(date) {
    const check = date.includes('T') ? date.split('T')[0] : date;
    const arr = check.split('-');

    // Formatação personalizada
    const day = arr[2].toString().padStart(2, '0');
    let month = (parseInt(arr[1]) - 1);
    const year = arr[0];

    const months = [
        'Jan', 'Fev', 'Mar', 'Abr',
        'Mai', 'Jun', 'Jul', 'Ago',
        'Set', 'Out', 'Nov', 'Dez',
    ];

    month = months[month];

    return `${day} ${month}, ${year}`;
}

export function convertUTCDateText(dateTime) {
    const dataUTC_obj = new Date(dateTime);

    // Ajustar para o fuso horário de Brasília (GMT-3)
    // Não precisamos fazer o ajuste manual pois o Date já interpreta o Z como UTC

    // Formatação personalizada
    const day = dataUTC_obj.getDate().toString().padStart(2, '0');
    let month = (dataUTC_obj.getMonth());
    const year = dataUTC_obj.getFullYear();

    const months = [
        'Jan', 'Fev', 'Mar', 'Abr',
        'Mai', 'Jun', 'Jul', 'Ago',
        'Set', 'Out', 'Nov', 'Dez',
    ];

    month = months[month];

    return `${day} ${month}, ${year}`;
}

export function convertHour(dateTime) {
    let date = dateTime.split(' ');
    date = date[1].split('.');

    return date[0];
}

export function showHide(show, hide, save) {
    if (save) {
        const card = document.getElementById(save);
        const height = card.offsetHeight;
        card.style.height = height + 'px';
    }
    $('#' + hide).hide();
    $('#' + show).show(300);
}

export function generateNickname(fullName) {
    // Dividir o nome completo em partes
    let nameParts = fullName.trim().split(" ");

    // Obter a primeira letra do primeiro nome
    let firstNameInitial = nameParts[0].charAt(0);

    // Obter a primeira letra do último nome
    let lastNameInitial = nameParts[nameParts.length - 1].charAt(0);

    // Combinar as letras para formar o nickname
    let nickname = firstNameInitial + lastNameInitial;

    return nickname.toUpperCase(); // Opcional: converter para maiúsculas
}

export function addZeros(string) {
    return String(string).padStart(2, '0');
}

export function httpError(response) {
    if (response.status === 401) {
        notifyError('Você precisa se autenticar!');
        router.push('/login');
    }

    if (typeof response.data === 'string') {
        notifyError(response.data);
    }
}

export function convertDateToISO(dateStr) {
    const [day, month, year] = dateStr.split('/');

    return `${year}-${month}-${day}`;
}

export function convertDateTimeToISO(dateStr) {
    if (!dateStr) return null;

    const regex = /^(\d{2})\/(\d{2})\/(\d{4})\s+(\d{2}):(\d{2})$/;
    const match = dateStr.match(regex);

    if (!match) return null;

    const [_, day, month, year, hours, minutes] = match;
    console.log(_)
    return `${year}-${month}-${day} ${hours}:${minutes}:00`;
}

export function convertDate(dateISO) {
    const [year, month, day] = dateISO.split('-');

    return `${day}/${month}/${year}`;
}

export function generateColor() {
    // Gera um número aleatório entre 0 e 16777215 (cor máxima em hexadecimal)
    const color = Math.floor(Math.random() * 16777215);

    // Converte para hexadecimal e garante que tenha 6 dígitos, adicionando zeros à esquerda se necessário
    return "#" + color.toString(16).padStart(6, "0");
}

export function encondeId(id) {
    return btoa(id.toString());
}

export function decodeId(id) {
    return atob(id.toString());
}

export function convertTextHtml(text) {
    // Preservar as quebras de linha substituindo "\n" por "<br>" para exibir no HTML
    return text ? text.replace(/\n/g, "<br>") : '';
}
